module.exports = __webpack_public_path__ + "img/intelligent3.cd963ff7.png";